"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._UpdateCorporateIdentitySettings = exports._InjectStencilWebComponents = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = require("lodash");
var _InjectStencilWebComponents = function () {
    if ((0, cash_dom_1.default)('#hacktrick-components').length === 0) {
        (0, exports._UpdateCorporateIdentitySettings)();
        // Create and append a script tag for module loading
        var scriptElement = document.createElement('script');
        scriptElement.id = 'hacktrick-components';
        scriptElement.type = 'module';
        scriptElement.textContent = "\n      import { defineCustomElements } from 'https://files.fittec.io/files/new-webcomponents/loader/index.es2017.js'; \n      defineCustomElements();\n    ";
        document.body.appendChild(scriptElement);
    }
};
exports._InjectStencilWebComponents = _InjectStencilWebComponents;
var defaultSettings = {
    allowChangeTheme: false,
    defaultTheme: 'light',
    addGlobalStyles: false, //<- required includes also var styles
    selectedTheme: 'light',
    relativePath: 'https://files.fittec.io/files/new-webcomponents/dist/corpident/shared',
};
var _UpdateCorporateIdentitySettings = function (newSettings) {
    if (newSettings) {
        defaultSettings = (0, lodash_1.merge)({}, defaultSettings, newSettings);
    }
    var doc = document;
    doc.corporateIdentity = defaultSettings;
};
exports._UpdateCorporateIdentitySettings = _UpdateCorporateIdentitySettings;
